__turbopack_context__.v({
  "categoryListContainer": "styles-module__B3JrRq__categoryListContainer",
  "categoryListFooter": "styles-module__B3JrRq__categoryListFooter",
  "categoryListItemsContainer__largeList": "styles-module__B3JrRq__categoryListItemsContainer__largeList",
  "categoryListItemsContainer__smallList": "styles-module__B3JrRq__categoryListItemsContainer__smallList" + " " + "styles-module__B3JrRq__categoryListItemsContainer__largeList",
  "categoryListLink": "styles-module__B3JrRq__categoryListLink",
  "categoryListTitle": "styles-module__B3JrRq__categoryListTitle",
  "categoryListitem": "styles-module__B3JrRq__categoryListitem",
});
